// const host = "http://localhost:8000/api";
const host = process.env.NODE_ENV == "development" ? "mmm" : "https://middleware.fahrschule-steininger.at/api"

import { DetailStep } from "../models/enums";
import { stateToPayloadCourse, stateToPayloadTraining } from "../models/helper";

let actions = {
  LOAD_LOCATIONS: (context) => {
    context.commit("setLoadingState", true);
    return new Promise((resolve, reject) => {
      fetch(`${host}/all_locations`)
        .then((response) => response.json())
        .then((responseJson) => {
          // console.log(responseJson);
          context.commit("updateAllLocations", responseJson);
          resolve("");
        })
        .catch((err) => reject(err))
        .finally(() => {
          context.commit("setLoadingState", false);
        });
    });
  },
  LOAD_TRAINING_DATES: (context) => {
    context.commit("setLoadingState", true);
    const url = `${host}/safety_trainings`
    return new Promise((resolve, reject) => {
      fetch(url)
        .then((response) => response.json())
        .then((responseJson) => {
          //console.log(responseJson);
          context.commit("updateAllTrainings", responseJson);
          resolve("");
        })
        .catch((err) => reject(err))
        .finally(() => {
          context.commit("setLoadingState", false);
        });
    });
  },
  SEND_TRAINING_APPLICATION: (context) => {
    context.commit("setLoadingState", true);

    return new Promise((resolve, reject) => {
      fetch(`${host}/safety_training_applications`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(stateToPayloadTraining(context.state)),
      })
        .then((response) => {
          if (!response.ok) {
            alert("Beim Absenden der Anmeldung ist ein Fehler aufgetreten.");
            throw new Error("Request failed");
          }
          return response.json();
        })
        .then(() => {
          context.commit("resetState");
          context.commit("updateStep", DetailStep.DONE);
        })
        .catch((err) => reject(err))
        .finally(() => {
          context.commit("setLoadingState", false);
        });
    });
  },
  LOAD_COURSE_DATES: (context) => {
    const url = `${host}/license_courses/location/${context.state.selectedLocation.ID}`;
    return new Promise((resolve, reject) => {
      context.commit("setLoadingState", true);
      fetch(url)
        .then((response) => response.json())
        .then((responseJson) => {
          //console.log(responseJson);
          context.commit("updateAllCourses", responseJson);
          resolve("");
        })
        .catch((err) => reject(err))
        .finally(() => {
          context.commit("setLoadingState", false);
        });
    });
  },
  SEND_COURSE_APPLICATION: (context) => {
    context.commit("setLoadingState", true);

    return new Promise((resolve, reject) => {
      fetch(`${host}/license_course_applications`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(stateToPayloadCourse(context.state)),
      })
        .then((response) => {
          if (!response.ok) {
            alert("Beim Absenden der Anmeldung ist ein Fehler aufgetreten.");
            throw new Error("Request failed");
          }
          return response.json();
        })
        .then(() => {
          context.commit("resetState");
          context.commit("updateStep", DetailStep.DONE);
        })
        .catch((err) => reject(err))
        .finally(() => {
          context.commit("setLoadingState", false);
        });
    });
  },
};

export default actions;
